import { render } from "./MediaMenu.vue?vue&type=template&id=4f86ca96"
import script from "./MediaMenu.vue?vue&type=script&lang=ts"
export * from "./MediaMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script